import { GlobalController } from 'src/shared/global/GlobalController'
import CommunicationHistory from './CommunicationHistory'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'service-order/communication-history',
    name:
      'serviceRequest.service-order.communication-history',
    component: CommunicationHistory,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
